import cn from 'classnames'
import { OnlyViewHoc } from 'hocs'
import * as React from 'react'

import styles from './AppLayout.module.scss'

type LinkItem = {
  title: string
  icon?: React.ReactNode
  onClick?(): void
}
interface Props {
  linksRight?: LinkItem[]
}

export const AppLayout: React.FC<Props> = ({ linksRight = [] }) => {
  return (
    <OnlyViewHoc>
      <div className={styles.links}>
        <div className={cn(styles.nav, 'container')}>
          <div className={styles.linksRight}>
            {linksRight.map(item => {
              return (
                <div
                  key={item.title}
                  onClick={item.onClick}
                  className={styles.linksRightItem}
                >
                  <div className={styles.linksRightItemIcon}>{item.icon}</div>
                  <div className={styles.linksRightItemTitle}>{item.title}</div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </OnlyViewHoc>
  )
}
